export default (blackList: string[]) => (propName: PropertyKey) =>
  !blackList.includes(String(propName));
